/**
 * This is the snippet that velaris asks you to add to your website to enable the widget. The variables have been
 * renamed to be more human-readable.
 */
export const addVelarisWidget = (clientId, userId, userName, userEmail) => {
    (function (
        globalWindow,
        documentObject,
        elementType,
        widgetFunctionName,
        widgetScriptURL,
        newScriptElement,
        firstScriptElement
    ) {
        if (globalWindow[widgetFunctionName]) {
            globalWindow[widgetFunctionName] = globalWindow[widgetFunctionName];
        } else {
            globalWindow[widgetFunctionName] = function () {
                globalWindow[widgetFunctionName].q.push(arguments);
            };
            globalWindow[widgetFunctionName].q = globalWindow[widgetFunctionName].q || [];
        }

        // Create a new script element
        newScriptElement = documentObject.createElement(elementType);
        firstScriptElement = documentObject.getElementsByTagName(elementType)[0];

        // Set properties of the new script element
        newScriptElement.id = widgetFunctionName;
        newScriptElement.src = widgetScriptURL;
        newScriptElement.async = true;

        // Insert the new script element before the first script element in the document
        firstScriptElement.parentNode.insertBefore(newScriptElement, firstScriptElement);
    })(
        window, // Global object
        document, // Document object
        "script", // Type of element to create
        "velaris_survey", // Name of the widget function
        "https://survey-widget.euw1.velaris.io/widget.js" // URL of the widget script
    );

    // Initialize the widget with the configuration object
    window.velaris_survey({
        apiKey: "JwDkk9mDey1BufJQ35vTd8HBQlxyipja3j11POLu",
        accountId: clientId,
        userId,
        userName,
        userEmail,
    });
};
